import { Ely1PerformanceObject } from '../'

export const getPerformanceObject = (): Ely1PerformanceObject => {
  const timingAPI: PerformanceTiming = window.performance.timing
  const startTime: number = timingAPI.navigationStart
  // if this function is called by an onLoad handler, loadEventEnd will be 0 so use loadEventStart insteads
  const endTime: number =
    timingAPI.loadEventStart > 0
      ? timingAPI.loadEventStart
      : timingAPI.loadEventEnd
  const totalTime: number = endTime - startTime

  const stats: Ely1PerformanceObject = {
    navigationTime: totalTime,
    redirectTime: timingAPI.redirectEnd - timingAPI.redirectStart,
    cacheTime: timingAPI.domainLookupStart - timingAPI.fetchStart,
    dnsTime: timingAPI.domainLookupEnd - timingAPI.domainLookupStart,
    connectionTime: timingAPI.connectEnd - timingAPI.connectStart,
    backendLoadTime: timingAPI.responseEnd - timingAPI.requestStart,
    domInteractiveTime: timingAPI.domInteractive - startTime,
    domParsingTime: timingAPI.domInteractive - timingAPI.domLoading,
    domReadyTime: timingAPI.domComplete - timingAPI.domInteractive,
    frontendLoadTime: timingAPI.loadEventStart - timingAPI.domInteractive,
  }

  return stats
}
